import { colors } from '@fikasio/styles';
import React from 'react';

const SIZES = {
  sm: '0.75em',
  md: '1em',
  '1x': '1em',
  lg: '1.33333em',
} as const;

type TrashIconProps = React.SVGAttributes<SVGSVGElement> & {
  size?: keyof typeof SIZES;
};

const TrashIcon = ({
  size = '1x',
  style,
  ...rest
}: TrashIconProps) => (
  <svg
    {...rest}
    aria-hidden="true"
    data-icon="trash"
    fill="currentColor"
    focusable="false"
    height={SIZES[size]}
    style={{
      color: colors.danger,
      display: 'inline-block',
      overflow: 'visible',
      verticalAlign: '-0.125em',
      ...style,
    }}
    viewBox="0 0 448 512"
    width={SIZES[size]}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M135.2 17.7C140.6 6.8 151.7 0 163.8 0h120.4c12.1 0 23.2 6.8 28.6 17.7L320 32h96c17.7 0 32 14.3 32 32s-14.3 32-32 32H32C14.3 96 0 81.7 0 64s14.3-32 32-32h96l7.2-14.3zM32 128h384v320c0 35.3-28.7 64-64 64H96c-35.3 0-64-28.7-64-64V128zm128 64c0-8.8-7.2-16-16-16s-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16V192zm80 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16V192zm80 0c0-8.8-7.2-16-16-16s-16 7.2-16 16v224c0 8.8 7.2 16 16 16s16-7.2 16-16V192z" />
  </svg>
);

export default TrashIcon;
